import type React from 'react';

// Shared "segmented control" look — one flat pill container (no per-button
// border), active segment gets a filled dark chip. Originally built for
// TextTool.tsx (Add Text); extracted here so PropertyPanel.tsx (Edit) can
// render the identical look for the same controls (type switcher, Bold/
// Italic/Underline, alignment) instead of a visually different bordered
// button style — per direct user request that Add and Edit not look/feel
// like two different tools.
export const segmentedGroup: React.CSSProperties = {
  display: 'flex', gap: 2, padding: 2,
  background: 'var(--panel-field-bg, #f1f2f4)', borderRadius: 8,
};

export function segmentBtn(active: boolean): React.CSSProperties {
  return {
    flex: 1, padding: '5px 0', border: 'none', borderRadius: 6, cursor: 'pointer',
    fontSize: 12, fontWeight: active ? 600 : 400,
    background: active ? 'var(--primary)' : 'transparent',
    color: active ? 'white' : 'var(--text)',
  };
}

export function iconSegmentBtn(active: boolean): React.CSSProperties {
  return {
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: '5px 8px', border: 'none', borderRadius: 6, cursor: 'pointer',
    background: active ? 'var(--primary)' : 'transparent',
    color: active ? 'white' : 'var(--text)',
  };
}
